import styled from 'styled-components';

import { CircleCheck } from '~/assets/svgs/index';

export const Container = styled.div``;

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding-left: 2%;
  justify-content: space-between;
`;

export const Title = styled.div`
  font-size: 2.2rem;
  color: ${({ theme }) => theme.colors.base[500]};
  font-weight: 700;
`;

export const Text = styled.div`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.base[500]};
  font-weight: 500;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2.5rem;
`;

export const PriorityDueDateWrapper = styled.div`
  background: #ffffff;
  border-radius: 10px;
  padding: 0.5rem 1rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

export const Label = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.base[500]};
`;

export const WrapperPriority = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    font-size: 1.3rem;
    color: ${({ theme }) => theme.colors.base[500]};
  }
`;

export const WrapperDueDate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    font-size: 1.3rem;
    color: ${({ theme }) => theme.colors.base[500]};
  }
`;

export const WrapperButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const WrapperForm = styled.div`
  display: flex;
  padding: 21px 32px 100px 32px;
  background: #ffffff;
  border-radius: 10px;
`;

export const WrapperCard = styled.div`
  height: ${({ height }) => height || '30rem'};
  margin-top: 2rem;
`;

export const CheckIcon = styled(CircleCheck).attrs(({ theme }) => ({
  color: theme.colors.base[400],
  size: 24,
}))`
  align-self: center;
`;

export const DeadlinePlaceholderWrapper = styled.div`
  width: 100%;
  border: 1px solid rgba(198, 204, 210, 0.3);
  background: white;
  display: flex;
  align-items: center;
  padding-left: 1rem;

  border-radius: 8px;
`;

export const DeadlinePlaceholder = styled.span`
  font-size: 1.4rem;
  color: #606474;
  font-weight: 400;
  line-height: 2.1rem;
`;
